import React from 'react';
import { Form, Input, Select } from 'antd';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { USER_ROLE_OPTIONS } from '../../../../data/constant';
import { useFetchCompany } from '../../Companies/hooks/useFetch';
function FormEmployee({ formRef, onFinish, initialValues = {} }) {  
  const isEdit = initialValues?.id != null;
  const { data: dataCompany } = useFetchCompany();
  const companyOptions = dataCompany ? dataCompany.map(company => ({
    value: company.id,
    label: company.companyName
  })) : [];
  return (
    <Form name="Form" ref={formRef} layout="vertical" onFinish={onFinish} initialValues={initialValues}>
      <div className='mt-5 grid lg:gap-x-5 lg:grid-cols-1 '>

        <Form.Item className='block mb-2 text-sm font-medium text-gray-700' name="UserName" label="ชื่อผู้ใช้" rules={[{ required: true, message: 'กรุณาระบุชื่อผู้ใช้' }]}>
          <Input
            className="w-full px-3 py-2 text-gray-700 border rounded-lg focus:outline-none"
            placeholder="ชื่อผู้ใช้"
          />
        </Form.Item>

        {/* ตอนแก้ไข: เว้นว่าง = ไม่เปลี่ยนรหัส
            เดิมช่องนี้ถูก prefill ด้วย bcrypt hash ที่ติดมากับ SELECT * ทำให้กดบันทึกทีไร
            ระบบเอา hash ไป hash ซ้ำ เจ้าตัวเลย login ไม่ได้ ตอนนี้ backend ไม่ส่ง hash มาแล้ว */}
        <Form.Item
          className='block mb-2 text-sm font-medium text-gray-700'
          name="password"
          label="รหัสผ่าน"
          rules={[{ required: !isEdit, message: 'กรุณาระบุรหัสผ่าน' }]}
          extra={isEdit ? 'เว้นว่างไว้ถ้าไม่ต้องการเปลี่ยนรหัสผ่าน' : undefined}
        >
          <Input.Password
            className="w-full px-3 py-2 text-gray-700 border rounded-lg focus:outline-none"
            placeholder={isEdit ? 'เว้นว่าง = ไม่เปลี่ยน' : 'รหัสผ่าน'}
            iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
          />
        </Form.Item>
        <Form.Item className='block mb-2 text-sm font-medium text-gray-700' name="userRole" label="Role" rules={[{ required: true, message: 'กรุณาระบุตำเเหน่ง' }]}>
          <Select
            defaultValue=""
            style={{ width: '100%' }}
            options={USER_ROLE_OPTIONS}
          />
        </Form.Item>
        <Form.Item className='block mb-2 text-sm font-medium text-gray-700' name="companyId" label="Company" rules={[{ required: true, message: 'กรุณาระบุบริษัท' }]}>
          <Select
            defaultValue=""
            style={{ width: '100%' }}
            options={companyOptions}
          />
        </Form.Item>
      </div>
    </Form>
  );
}

export default FormEmployee;

